/**
 * Fiscal Registration
 * Fiskal Cloud Keycloak API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ArchiveUserStatusDTO } from './archive-user-status-dto';


/**
 * Request for status update
 */
export interface ArchiveUserStatusBodyDTO { 
    status: ArchiveUserStatusDTO;
}

export class ClsArchiveUserStatusBodyDTO { 
    status: ArchiveUserStatusDTO = undefined;
}



